<div class="button-container">
  <label>
    <input
      type="file"
      accept="image/*,image/heic,image/heif"
      multiple="false"
      (change)="attachImage($event)"
      style="display: none"
      #fileInput
    />
    <app-button
      dataLabel="change-button"
      [buttonOptions]="{ variant: 'secondary' }"
      class="change-button mt-16"
      (click)="triggerFileInput()"
      (keydown)="handleKeydown($event, 'file')"
      [title]="'Attach image'"
    >
      <i class="fa-light fa-image fa-xl"></i>
      <p class="body bold mt-4">Attach image</p>
    </app-button>
  </label>

  <!-- Should open camera on mobile -->

  <label class="camera-button">
    <input type="file" accept="image/*" capture="environment" multiple="false" (change)="attachImage($event)" />
    <app-button dataLabel="change-button" [buttonOptions]="{ variant: 'secondary' }" class="change-button mob mt-16">
      <i class="fa-light fa-camera fa-xl"></i>
      <p class="body bold mt-4">Take Photo</p>
    </app-button>
  </label>
</div>
